import { LoginFormValues } from '../login-form.interface'

export const getLoginInitialValues = (form?: LoginFormValues) => {
  if (form) {
    return {
      email: form.email,
      password: form.password,
    }
  }

  return {
    email: null,
    password: null,
  }
}
